// 美居社区化

// 基础路径判断
let protocol = window.location.protocol; // 协议
// 测试环境，域名的时候 http://cmms2.midea.com/
let baseApi = process.env.BASE_API;
let prefixMeiju = '/dcpServiceOpmange/supervisor';
if (window.location.href.indexOf('://cmms2') >= 0) {
  baseApi = 'http://cmms2.midea.com/';
}
if (protocol === 'https:') {
  baseApi = baseApi.replace('http:', 'https:');
}

/** 账号管理 */
// 账号列表查询（可调试）
export const QRY_SOCIAL_ACCOUNT_LIST = prefixMeiju + '/socialAccount/qrySocialAccountList';
// 新增账号（其他功能调用）
export const SOCIAL_ACCOUNT_ADD_SOCIAL_ACCOUNT = prefixMeiju + '/socialAccount/addAccountByMobileList';
// 账号取消禁言
export const UNFORBIDDEN_ACCOUNT = prefixMeiju + '/socialAccount/unforbiddenAccount';
// 账号禁言
export const FORBIDDEN_ACCOUNT = prefixMeiju + '/socialAccount/forbiddenAccount';
// 设置账号类型
export const SOCIAL_ACCOUNT_SET_ACCOUNT_TYPE = prefixMeiju + '/socialAccount/updateAccount';
// 批量导入马甲号
export const BATCH_ADD_VEST_ACCOUNT = baseApi + 'dcpServiceOpmange/supervisor/socialAccount/batchAddVestAccount';
// 编辑马甲账号
export const EDIT_VEST_ACCOUNT = prefixMeiju + '/socialAccount/editVestAccount';
// 手动设置粉丝数
export const SET_VEST_FANS_BY_UIDS = prefixMeiju + '/socialAccount/setVestFansByUids';
// 查看账号信息
export const QRY_ACCOUNT_BY_UID = prefixMeiju + '/socialAccount/qryAccountByUid';
// 同步dcp账号
export const SOCIAL_ACCOUNT_SYNC_ACCOUNT = prefixMeiju + '/socialAccount/syncAccount';
// 导出账号
export const ACCOUNT_EXPORT = prefixMeiju + '/socialAccount/export';
// 设置大咖
export const SET_MASTER = prefixMeiju + '/circle/account/add';
// 取消大咖
export const REMOVE_MASTER = prefixMeiju + '/circle/account/remove';

/** 举报管理 */
// 账号举报列表
export const QRY_SOCIAL_REPORT_LIST = prefixMeiju + '/socialAccount/qrySocialReportList';
// 动态举报列表
export const LIST_POST_REPORT = prefixMeiju + '/post/listPostReport';
// 账号举报详情
export const QRY_SOCIAL_REPORT_BY_ID = prefixMeiju + '/socialAccount/qrySocialReportById';
// 动态举报详情
export const POST_REPORT_DETAIL_INFO = prefixMeiju + '/post/postReportDetailInfo';
// 账号举报处理
export const SOCIAL_ACCOUNT_REPORT_HANDEL = prefixMeiju + '/socialAccount/reportHandel';
// 账号举报处理
export const AUDIT_POST_REPORT = prefixMeiju + '/post/auditPostReport';
// 内容申诉列表查询
export const APPEAL_LIST = '/dcpServiceOpmange/supervisor/content/appeal/list';
// 内容申诉处理
export const APPEAL_DISPOSE = '/dcpServiceOpmange/supervisor/content/appeal/dispose';
// 内容申诉详情
export const APPEAL_INFO = '/dcpServiceOpmange/supervisor/content/appeal/info';
// 账号申诉列表查询
export const QRY_ACCOUNT_APPEAL_LIST = '/dcpServiceOpmange/supervisor/socialAccount/qryAccountAppealList';
// 账号申诉处理
export const ACCOUNT_APPEAL_HAND = '/dcpServiceOpmange/supervisor/socialAccount/accountAppealHand';
// 账号申诉详情
export const QRY_ACCOUNT_APPEAL_DETAIL = '/dcpServiceOpmange/supervisor/socialAccount/qryAccountAppealDetail';

// 动态管理
// 动态列表
export const POST_LIST = prefixMeiju + '/post/list';
// 后台统计近三个月动态数
export const STATISTIC = prefixMeiju + '/post/statistic';
// 动态审核
export const POST_AUDIT = prefixMeiju + '/post/verify';
// 风控设置
export const POST_CONTROL = prefixMeiju + '/post/updatePostInfo';
// 动态屏蔽
export const POST_HIDDEN = prefixMeiju + '/post/hidden';
// 审核详情
export const AUDIT_DETAIL = prefixMeiju + '/post/verify/latestRecord';
// 导入动态
export const IMPORT_DYNAMIC = (process.env.ENV_CONFIG === 'dev' ? '/test' : '') + prefixMeiju + '/post/loadData';
// 导入任务
export const DYNAMIC_TASK = prefixMeiju + '/post/loadData/jobs/10';
// 导出动态
export const DYNAMIC_EXPORT = prefixMeiju + '/post/export';
// 发布动态
export const PUBLISH_DYNAMIC = prefixMeiju + '/post/publish';
// 获取签名
export const GET_SIGNATURE = prefixMeiju + '/post/uploadVideo';
// 获取视频截帧
export const GET_VIDEO_SNAPSHOT = prefixMeiju + '/post/getVideoSnapshot';
// 编辑动态
export const UPDATE_DYNAMIC = prefixMeiju + '/post/update';
// 删除动态
export const DELETE_DYNAMIC = prefixMeiju + '/post/delete';
// 动态详情
export const POST_DETAIL = prefixMeiju + '/post/detail';
// 个人动态
export const HOME_PAGE_LIST = prefixMeiju + '/post/own';
// 禁言记录
export const MUTE_PAGE_LIST = prefixMeiju + '/socialAccount/getForbiddenList';
// 个人动态置顶
export const HOME_PAGE_TOP = prefixMeiju + '/post/own/top';
// 个人动态取消置顶
export const HOME_PAGE_DEL_TOP = prefixMeiju + '/post/own/delTop';
// 动态置顶
export const POST_TOP = prefixMeiju + '/post/top';
// 取消置顶
export const POST_DEL_TOP = prefixMeiju + '/post/delTop';
// 动态推荐
export const SET_RECOMMEND = prefixMeiju + '/circle/post/recommend';
// 取消推荐
export const CANCEL_RECOMMEND = prefixMeiju + '/circle/post/cancelRecommend';
// 标签和关键词
export const UPDATE_CONTENT_TAG_AND_SEARCH_KW = prefixMeiju + '/post/updateContentTagAndSearchKW';
// 评论动态
export const REPLY_COMMENT_INFO = prefixMeiju + '/post/replyCommentInfo';
// 点赞动态
export const THUMS_UP = prefixMeiju + '/post/bgLikePost';
// 投票明细
export const VOTE_LIST = prefixMeiju + '/vote/voteParticipant/list';
// 导出投票明细
export const EXPORT_VOTE_LIST = prefixMeiju + '/vote/voteParticipant/export';
// 评论列表
export const POST_COMMENT = prefixMeiju + '/post/qryCommentBgInfo';
// 评论屏蔽
export const COMMENT_SHIELD = prefixMeiju + '/post/shieldCommentInfo';
// 评论折叠
export const COMMENT_FOLD = prefixMeiju + '/post/foldCommentInfo';
// 评论置顶
export const COMMENT_TOP = prefixMeiju + '/post/topCommentInfo';
// 频道列表
export const GET_CHANNEL_LIST = prefixMeiju + '/post/getChannelList';
// 文章标签分类列表
export const GET_CC_LABEL_CATEGORY_LIST = prefixMeiju + '/post/queryCategoryAll';
// 频道列表
export const GET_CC_CHANNEL_LIST = prefixMeiju + '/post/queryChannel';
// 关联频道
export const SET_CHANNEL_INFO = prefixMeiju + '/post/setChannelInfo';
// 关联话题
export const SET_TOPIC = prefixMeiju + '/post/setTopic';
// 点赞账号列表
export const GET_ACCOUNT_FOR_LIKE = prefixMeiju + '/socialAccount/getAccountForLike';
// 获取虚拟账号
export const GET_RAND_VIRTUAL_ACCOUNT = prefixMeiju + '/socialAccount/getRandVirtualAccount';
// 获取官方/达人账号
export const QRY_ACCOUNT_FOR_DYNAMIC = prefixMeiju + '/socialAccount/qryAccountForDynamic';
// 食谱列表recipeList
export const RECIPE_LIST = prefixMeiju + '/post/recipes';
// 上传图片和视频
export const DYNAMIC_UPLOAD = (process.env.ENV_CONFIG === 'dev' ? '/test' : '') + prefixMeiju + '/post/upload';
// 圈子列表
export const CIRCLE_LIST = prefixMeiju + '/circle/list';

// 达人后台
// 列表查询
export const TALENT_POST_LIST = prefixMeiju + '/talent/post/list';
// 详情
export const TALENT_POST_DETAIL = prefixMeiju + '/talent/post/detail';
// 发布动态
export const PUBLISH_TALENT = prefixMeiju + '/talent/post/publish';
// 删除动态
export const DELETE_TALENT = prefixMeiju + '/talent/post/delete';


// 标签管理
// 标签列表
export const TAG_LIST = prefixMeiju + '/tag/tagList';
// 新增标签
export const ADD_TAG = prefixMeiju + '/tag/insertTag';
// 修改标签
export const EDIT_TAG = prefixMeiju + '/tag/updateTag';
// 删除标签
export const DELETE_TAG = prefixMeiju + '/tag/deleteTag';
// dcp标签
export const DCP_TAG_LIST = prefixMeiju + '/post/queryContentTag';

// 内容中心标签
export const CC_TAG_LIST = prefixMeiju + '/post/queryArticleLabelAll';
// 话题管理
// 话题列表
export const TOPIC_LIST = prefixMeiju + '/topic/list';
// 更新话题
export const UPDATE_TOPIC = prefixMeiju + '/topic/update';
// 新增话题
export const ADD_TOPIC = prefixMeiju + '/topic/add';
// 删除话题
export const DELETE_TOPIC = prefixMeiju + '/topic/delete';
// 推荐、取消推荐话题
export const RECOMMEND_TOPIC = prefixMeiju + '/topic/recommend';
// 关注话题
export const FOLLOW_TOPIC = prefixMeiju + '/topic/follow';
// 取消关注话题
export const UNFOLLLOW_TOPIC = prefixMeiju + '/topic/unfollow';
// 搜索联想话题
export const QUERY_TOPIC = prefixMeiju + '/topic/query';
// 获取话题详情
export const TOPIC_DETAIL = prefixMeiju + '/topic/detail';
// 批量上下架
export const TOPIC_STATUS = prefixMeiju + '/topic/status';
